<template>
  <ConfiguratorLevel3Mobile v-if="$store.getters.isMobile && $store.getters.getCurrentLevel === 3" />
  <ConfiguratorLevel3Desktop v-else-if="$store.getters.getCurrentLevel === 3" />
</template>

<script>
import ConfiguratorLevel3Desktop from '@/views/step1/ConfiguratorLevel3Desktop';
import ConfiguratorLevel3Mobile from '@/views/step1/ConfiguratorLevel3Mobile';
import { loadingMixin } from '@/mixins/LoadingMixin';
import { logicMixin } from '@/mixins/LogicMixin';
import { TrackingMixin } from '@/mixins/TrackingMixin';

export default {
  components: {
    ConfiguratorLevel3Desktop,
    ConfiguratorLevel3Mobile,
  },
  mixins: [loadingMixin, logicMixin, TrackingMixin],
  mounted: function () {
    this.loadFromStorage();
    this.init();

    this.$root.$on('level3Loaded', () => {
      this.loadFromStorage();
    });
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
  methods: {
    loadFromStorage() {
      this.$store.commit('setCurrentLevel', 3);
      this.$store.commit('setLevel3Available', false);
      this.$store.commit('setLevel3NotAvailable', false);

      if (
        this.$store.getters.getSelectedItem.data !== null &&
        this.$store.getters.getSelectedItem.data.type !== 'level_3'
      ) {
        this.$store.commit('setSelectedItem', null);
      }

      const params = new URLSearchParams(window.location.search);
      if (params.has('__addLevel3')) {
        var defaultItem = null;
        this.$store.getters.getListItemsLevel3.forEach((product) => {
          if (product.id === parseInt(params.get('__addLevel3'))) {
            defaultItem = product;
          }
        });
        this.addLevel3(defaultItem);
      } else if (params.has('__addLevel3s')) {
        this.$store.commit('clearLevel3FilterBrand');
        this.$store.commit('clearLevel3FilterCategory');
        this.$store.commit('clearLevel3FilterAttribute');
        this.$store.commit('setLevel3FilterMinPrice', 0);
        this.$store.commit('setLevel3FilterMaxPrice', 99999);
        this.$store.commit('setLevel3FilterUseB2cPrices', false);
        this.$store.commit('setLevel3FilterB2bQty', 0);
        this.$store.commit('setLevel3FilterB2bTime', -1);
        this.$store.commit('setLevel3FilterFreeSearch', '');
        const listIds = params.get('__addLevel3s').split(',').map(i => parseInt(i));
        this.$store.getters.getListItemsLevel3.forEach((product) => {
          if (listIds.includes(product.id)) {
            this.addLevel3(product);
          }
        });
      } else {
        if (
          localStorage.getItem('lastSelectedItemLevel3') !== null
        ) {
          var canLoad = true;
          const savedItem = JSON.parse(
            localStorage.getItem('lastSelectedItemLevel3')
          );
          savedItem.data.products.forEach((savedProduct) => {
            var isIn = false;
            this.$store.getters.getListItemsLevel3.forEach((item) => {
              if (savedProduct.id === item.id) {
                if (
                  this._.isEqual(item.dim_x, savedProduct.dim_x) &&
                      this._.isEqual(item.dim_y, savedProduct.dim_y) &&
                      this._.isEqual(
                        item.originalPrice,
                        savedProduct.originalPrice
                      ) &&
                      this._.isEqual(
                        item.originalPriceNet,
                        savedProduct.originalPriceNet
                      ) &&
                      this._.isEqual(item.price, savedProduct.price) &&
                      this._.isEqual(item.rotatable, savedProduct.rotatable) &&
                      this._.isEqual(
                        item.stock_quantity,
                        savedProduct.stock_quantity
                      ) &&
                      this._.isEqual(
                        item.custom_delivery_qty,
                        savedProduct.custom_delivery_qty
                      )
                ) {
                  isIn = true;
                } else {
                  canLoad = false;
                }
              }
            });

            if (!isIn) {
              canLoad = false;
            }
          });

          if (canLoad) {
            this.$store.getters.getBoxItemsLevel3.forEach((box) => {
              if (
                box.id === savedItem.data.box.id &&
                    this._.isEqual(box, savedItem.data.box)
              ) {
                this.$store.commit('setSelectedItem', savedItem.data);
                this.$root.$emit('boxPreviewInside');
                this.updateAfterLevel3();
              }
            });
          }
        } else if (localStorage.getItem('lastSelectedItemLevel3') !== null) {
          const savedItem = JSON.parse(
            localStorage.getItem('lastSelectedItemLevel3')
          );
          this.$store.commit('setSelectedItem', savedItem.data);
          this.$root.$emit('boxPreviewInside');
          this.updateAfterLevel3();
        }
      }
    },
    init: function () {
      if (this.$route.name === 'ConfiguraterLevel3ModalProduct') {
        this.$store.getters.getListItemsLevel3.forEach((item) => {
          if (item.id === parseInt(this.$route.params.mod)) {
            this.$store.commit('setModalItem', item);
          }
        });
        this.$store.commit('setModalOpen', true);

        this.criteoTracking({
          event: 'viewItem',
          item: this.$route.params.mod
        });
      } else {
        this.$store.commit('setModalOpen', false);

        this.criteoTracking({
          event: 'viewList',
          item: this.$store.getters.getListItemsLevel3Filtered.map(product => product.id.toString()),
          category: 'Level 3',
          keywords: ''
        });
      }
    },
  },
  metaInfo () {
    return {
      title: 'Individuelle Präsente'
    };
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/views/level';
</style>
